// -----------------------------------------------------------------------------
// Anaglyphic, Netherlands @ 2023.
// See README in the root project for more information.
// -----------------------------------------------------------------------------

import { Component } from "vue";
import { RouteMeta, RouteLocationNormalized } from "vue-router";

/** Modify the Vue-Router meta intertface with out own definitions. */
declare module "vue-router" {
	interface RouteMeta {
		/** The localizable key used get the route name */
		navigationTranslationKey?: string;
		showInNavigationBar?: boolean;
		requiresAuth?: boolean;
		isModuleBaseRoute?: boolean;
		permissions?: string[];
	}
}

/** Base route class for all routes. */
export default class Route {
	constructor(
		public name: string,
		public path: string,
		public component: Component, // TODO: Specify explicit type.
		public children: Route[],
		public meta: RouteMeta = {
			isModuleBaseRoute: false,
			requiresAuth: true,
		},
		public redirect: string | ((to: RouteLocationNormalized) => string) = "",
		public alias: string | string[] = [],
		public props: Object | boolean = {}
	) {}
}
